module.exports = __webpack_public_path__ + "static/media/scoutNotification.f637a03b.png";